import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

/**
 * Active organization (tenant) for *this tab*.
 *
 * Persisted in sessionStorage so each browser tab can work in a different
 * organization; the API client sends it as `X-Tenant-Id` on every request.
 * When unset, the server falls back to the session's remembered tenant.
 */
interface TenantState {
  tenantId: number | null
  setTenantId: (id: number | null) => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      tenantId: null,
      setTenantId: (tenantId) => set({ tenantId }),
    }),
    {
      name: "mit.tenant",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
